import type { AmcOR } from "@amerisave/amc-or-integration";

let trackerPromise: Promise<AmcOR> | null = null;

const getOpenReplayTracker = (): Promise<AmcOR> => {
  if (!trackerPromise) {
    trackerPromise = import("@amerisave/amc-or-integration").then(
      ({ AmcOR }) =>
        new AmcOR(process.env.NEXT_PUBLIC_OPEN_REPLAY_WWW_PROJECT_KEY ?? "", {
          devMode:
            process.env.NEXT_PUBLIC_OPEN_REPLAY_DEV_MODE?.toLowerCase() ===
            "true", // true for development mode, false for production
          skipAssist:
            process.env.NEXT_PUBLIC_OPEN_REPLAY_SKIP_ASSIST?.toLowerCase() ===
            "true", // skips live-session recording, useful when running locally
          openReplayOptions: {
            __DISABLE_SECURE_MODE:
              process.env.NEXT_PUBLIC_OPEN_REPLAY_DISABLE_SECURE_MODE?.toLowerCase() ===
              "true", // enables running locally for debugging purpose
            ingestPoint: process.env.NEXT_PUBLIC_OPEN_REPLAY_INGEST_POINT,
          },
        }),
    );
  }

  return trackerPromise;
};

export default getOpenReplayTracker;
